import { api } from "./client";
import config from "../config";

export const createSchedule = async (data) => {
  try {
    const response = await api.post("/api/schedules", data);
    return response.data;
  } catch (error) {
    console.error("Error creating schedule:", error);
    throw error;
  }
};

export const getSchedules = async (filters) => {
  try {
    const response = await api.post("/api/schedules/admin", filters);
    return response.data;
  } catch (error) {
    console.error("Error fetching schedules:", error);
    throw error;
  }
};

export const updateSchedule = async (data, scheduleId) => {
  try {
    const response = await api.put(`/api/schedules/${scheduleId}`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating schedule:", error);
    throw error;
  }
};

export const deleteSchedule = async (scheduleId) => {
  try {
    const response = await api.delete(`/api/schedules/${scheduleId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting schedule:", error);
    throw error;
  }
};

export const getSchedulesByUser = async (userId) => {
  try {
    const response = await api.get(`/api/schedules/user/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching schedules by user:", error);
    throw error;
  }
};

export const getSchedulesForAdmin = async (filters) => {
  try {
    const response = await api.post("/api/schedules/admin", filters);
    return response.data;
  } catch (error) {
    console.error("Error fetching schedules for admin:", error);
    throw error;
  }
};

export const getSchedulesForCoach = async (filters) => {
  try {
    const response = await api.post("/api/schedules/coach", filters);
    return response.data;
  } catch (error) {
    console.error("Error fetching schedules for coach:", error);
    throw error;
  }
};

export const getSchedulesCoach = async (filters) => {
  try {
    const response = await api.post("/api/schedules/coach", filters);
    return response.data;
  } catch (error) {
    console.error("Error fetching schedules for coach:", error);
    throw error;
  }
};

// Every Balagruha ({ _id, name }), for the Balgruha filter of the coach Daily Lesson Plan.
export const getScheduleBalagruhas = async () => {
  const response = await api.get("/api/schedules/balagruhas");
  return response.data?.data?.balagruhas || [];
};

// Published scene / story / poem / Life Skills course content by One-on-One column, for the coach
// Daily Lesson Plan's dropdowns (the same list as the admin's getLessonPlanCatalog).
export const getSchedulePlanCatalog = async () => {
  const response = await api.get("/api/schedules/plan-catalog");
  return response.data?.data || {};
};

export const updateScheduleStatus = async (scheduleId, status) => {
  try {
    const response = await api.put(`/api/schedules/status/${scheduleId}`, {
      status,
    });
    return response.data;
  } catch (error) {
    console.error("Error updating schedule status:", error);
    throw error;
  }
};

// Uploads files for a schedule; returns [{ filename, s3Key, mimeType, size, uploadedAt }] to send
// as `attachments` when creating the schedule.
export const uploadScheduleAttachments = async (files) => {
  const formData = new FormData();
  files.forEach((file) => formData.append("files", file));
  const response = await api.post("/api/schedules/attachments", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data?.data?.attachments || [];
};

// The attachment route needs the auth header, so fetch it as a blob instead of linking to it.
export const getScheduleAttachmentBlob = async (scheduleId, attachmentId) => {
  const response = await api.get(`/api/schedules/${scheduleId}/attachments/${attachmentId}`, {
    responseType: "blob",
  });
  return response.data;
};

// Key for a visit's share link (one Balagruha on one day); see visitShareUrl in DailyScheduleVisitModals.
export const getScheduleShareKey = async (balagruhaId, date) => {
  const response = await api.post("/api/schedules/share-link", { balagruhaId, date });
  return response.data?.data?.key;
};

// Public (no login): the visit a share link points at.
export const getSharedSchedule = async ({ date, key }) => {
  const response = await api.get("/api/schedules/shared", { params: { date, key } });
  return response.data?.data;
};

// Public (no login) link to an attachment of a shared visit.
export const sharedScheduleAttachmentUrl = ({ scheduleId, attachmentId, date, key }) =>
  `${config.API_BASE_URL}/api/schedules/shared/attachments/${scheduleId}/${attachmentId}?${new URLSearchParams({ date, key })}`;
